export function fixSvgIntrinsicSizing() {
  /**
   * fixSvgIntrinsicSizing
   * IEのインラインSVGの固有サイズ表示をSVG1.1仕様に修正
   * おまけで、preserveAspectRatioが'slice'だった場合に'overflow:hidden'を適用
   * 注意：svg要素にはviewBox属性を必須としています
   * なお、特定のsvg要素への適用を避けたい場合には、そのsvg要素にclass="noFixSvgIntrinsicSizing"を付与してください
   * Fix inline SVG intrinsic sizing in IE.
   * Plus, add 'overflow:hidden' when preserveAspectRatio has 'slice' value.
   * NOTE: 'viewBox' attribute is required in svg element.
   * To prevent applying to the specific svg element, add class="noFixSvgIntrinsicSizing" to that svg element.
   * Copyright (c) 2014-2016 Kazz
   * http://asamuzak.jp
   * Dual licensed under MIT or GPL
   * http://asamuzak.jp/license
   */
  if(document.documentMode) {
    var fixSvgIntrinsicSizing = function() {
      function getAspect(o) {
        return (o = o.split(" ")) && o[3] / o[2];
      }
      var x = document.querySelectorAll("svg[viewBox]");
      if(x) {
        for(var y, z, a, b, i = 0, l = x.length; i < l; i++) {
          y = x[i];
          if(!/noFixSvgIntrinsicSizing/.test(y.className.baseVal)) {
            y.hasAttribute("preserveAspectRatio") &&
              /slice/.test(y.getAttribute("preserveAspectRatio")) &&
              (y.style.overflow = "hidden");
            a = window.getComputedStyle(y, "").width;
            b = window.getComputedStyle(y, "").height;
            y.style.width = "";
            y.style.height = "";
            z = window.getComputedStyle(y, "").height;
            if(z !== "150px") {
              y.style.width = a;
              y.style.height = b;
            }
            else {
              z = window.getComputedStyle(y, "").width;
              a = /([0-9\.]+)px/.exec(z)[1] * 1;
              b = getAspect(y.getAttribute("viewBox"));
              a * b > document.documentElement.offsetHeight && (
                y.style.height = (a * b) + "px",
                z = window.getComputedStyle(y, "").width,
                a = /([0-9\.]+)px/.exec(z)[1] * 1
              );
              y.style.width = z;
              y.style.height = (a * b) + "px";
            }
          }
        }
      }
    };
    document.addEventListener("DOMContentLoaded", fixSvgIntrinsicSizing, false);
    window.addEventListener("resize", fixSvgIntrinsicSizing, false);
  }
}